module.exports = __webpack_public_path__ + "img/dongji_ps_03.2e810d96.jpg";